const onRouteUpdate = (args: { prevLocation: { pathname: string } }) => {
	const { prevLocation } = args;

	localStorage.setItem("prevLocation", prevLocation ? prevLocation.pathname : "/");
};

export default onRouteUpdate;
